<!-- 暂无数据 -->
<template>
  <!-- {{$t('common.noData') || data}} -->
  <div class="bl-no-data">
    <el-empty :description="$t('common.noData') || data"></el-empty>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  name: 'noData',
  components: {},
  data() {
    return {}
  }
}
</script>
<style lang="stylus" scoped>
.bl-no-data{
  text-align center
  padding-top: 40px;
  padding-bottom: 80px;
}
</style>
